import Vue from 'vue'

import { createPerson, getItemByValue } from '../utils'

export default {
	// Update self audio track
	updateAudioTrack(state, track) {
		Vue.set(state.self.tracks, 'audio', track)
	},

	// Update self video track
	updateVideoTrack(state, track) {
		Vue.set(state.self.tracks, 'audio', track)
	},

	// Update or disconnect group ID
	setGroupID(state, groupID) {
		if(groupID != undefined) {
			Vue.set(state, 'groupID', groupID);
			Vue.set(state, 'connected', true);
		} else {
			Vue.set(state, 'groupID', '');
			Vue.set(state, 'connected', false);
		}
	},

	addPeer(state, peer) {
		console.log('ADDPEER', peer.id, peer.data);
		let person = createPerson(peer.data);
		console.log(peer.id, person);
		Vue.set(state.peers, peer.id, person);
	},

	removePeer(state, peer_id) {
		if (peer_id in state.peers) {
			state.peers[peer_id].connection.close();
			Vue.delete(state.peers, peer_id);
		}
	},

	addTrackToPeer(state, {peer_id, track}) {
		Vue.set(state.peers[peer_id].tracks, track.kind, track);
    },
    
    setName(state, {name, peer_id}) {
        if(peer_id) {
			// update name of peer
			Vue.set(state.peers[peer_id], 'name', name);
		} else {
			// update name of self
			Vue.set(state.self, 'name', name);
		}
    },

	setPosition(state, {point, peer_id}) {
		if(peer_id) {
			// update position of peer
			Vue.set(state.peers[peer_id], 'x', point.x);
			Vue.set(state.peers[peer_id], 'y', point.y);
		} else {
			// update position of self
			Vue.set(state.self, 'x', point.x);
			Vue.set(state.self, 'y', point.y);
		}
    },
    
    setDirection(state, {angle, peer_id}) {
        if(peer_id) {
            // update direction of peer
            Vue.set(state.peers[peer_id], 'angle', angle);
        } else {
            // update direction of self
            Vue.set(state.self, 'angle', angle);
        }
	},

	setFaceDistance(state, {distance, peer_id}) {
        if(peer_id) {
            // update face distance of peer
            Vue.set(state.peers[peer_id], 'faceDistance', distance);
        } else {
            // update face distance of self
            Vue.set(state.self, 'faceDistance', distance);
        }
	},

    setPointer(state, {pointer, peer_id}) {
        if(peer_id) {
            // update pointer of peer
            Vue.set(state.peers[peer_id], 'pointer', pointer);
        } else {
            // update pointer of self
            Vue.set(state.self, 'pointer', pointer);
        }
    },

    setColor(state, {color, peer_id}) {
        if(peer_id) {
            // update color of peer
            Vue.set(state.peers[peer_id], 'color', color);
        } else {
            // update color of self
            Vue.set(state.self, 'color', color);
        }
	},
	
	setMuted(state, {muted, peer_id}) {
		if(peer_id) {
			// update muted state of peer (for visual effect)
			Vue.set(state.peers[peer_id], 'muted', muted);
		} else {
			// update muted state of self
			Vue.set(state.self, 'muted', muted);
		}
	},

    setOrder(state, {order, peer_id}) {
        if(peer_id) {
            // update order of peer
            Vue.set(state.peers[peer_id], 'order', order);
        } else {
            // update order of self
            Vue.set(state.self, 'order', order);
        }
	},
	
	setPlaying(state, value) {
		Vue.set(state.boombox, 'playing', value);
	},

	addPlaylistItem(state, data) {
		Vue.set(state.boombox, 'playlist', [...state.boombox.playlist, data])
	},

	setCurrent(state, value) {
		Vue.set(state.boombox, 'current', value);
	},

	setPlaylist(state, playlist) {
		Vue.set(state.boombox, 'playlist', playlist);
	},

	/* OBJECTS */
	
	setObjects(state, objects) {
		Vue.set(state, 'objects', objects);
	},

	setObjectProps(state, props) {
		for(let i = 0; i < props.length; i++) {
			let data = props[i];
			let object = getItemByValue(state.objects, 'id', data.id);

			let prop = data.prop;
			
			while(prop.indexOf('.') !== -1) {
				let index = prop.indexOf('.');
				let parentProp = prop.slice(0, index);
				prop = prop.slice(index + 1);

				object = object[parentProp]
			}

			if(object != undefined) {
				Vue.set(object, prop, data.value);
			}
		}
	},

	createObject(state, object) {
		//Vue.set(state.objects, object.id, object);
		state.objects.push(object);
	},

	destroyObject(state, object_id) {
		let object = getItemByValue(state.objects, 'id', object_id);
		if(object != undefined) {
			// If we delete the object by id, it messes up all other objects
			// Not sure what the best way to remove would be
			// perhaps build up a new object array instead of deleting?
			
			//Vue.delete(state.objects, object_id);
			//Vue.set(state.objects, object_id, null);
			state.objects.splice(state.objects.indexOf(object), 1)
		}
	},

	/* ROOMS */

	setRooms(state, rooms) {
		Vue.set(state, 'rooms', rooms);
	},

	setRoomProps(state, props) {
		for(let i = 0; i < props.length; i++) {
			let data = props[i];
			let room = getItemByValue(state.rooms, 'id', data.id);

			let prop = data.prop;
			
			while(prop.indexOf('.') !== -1) {
				let index = prop.indexOf('.');
				let parentProp = prop.slice(0, index);
				prop = prop.slice(index + 1);

				room = room[parentProp]
			}

			if(room != undefined) {
				Vue.set(room, prop, data.value);
			}
		}
	},

	createRoom(state, room) {
		//Vue.set(state.objects, object.id, object);
		state.rooms.push(room);
	},

	destroyRoom(state, room_id) {
		let room = getItemByValue(state.rooms, 'id', room_id);
		if(room != undefined) {
			state.rooms.splice(state.rooms.indexOf(room), 1)
		}
	},

	/* CHAT */
	
	/*setEmote(state, {emote, peer_id}) {
		if (peer_id) {
			Vue.set(state.peers[peer_id], 'emote', {emote});
		} else {
			Vue.set(state.self, 'emote', {emote});
		}
	},*/

	appendChat(state, {chat, peer_id}) {
		Object.assign(chat, { lifetime: 3000 + chat.text.length * 50, received: Date.now() })

		if (peer_id) {
			state.peers[peer_id].messages.push(chat)
		} else {
			state.self.messages.push(chat)
		}
	},

	setAudioContext(state) {
		if (state.audioContext == undefined) {
			try {
				state.audioContext = new AudioContext();
			} catch (TypeError) {
				// Safari Desktop & Mobile use webkitAudioContext
				state.audioContext = new window.webkitAudioContext();
			}
		}
	},

	/* OTHER */

	setContextMenu(state, data) {
		state.menu = data;
	},

	setObjectMode(state, objectMode) {
		state.objectMode = objectMode;
	},

	setBroadcast(state, {value, peer_id}) {
		console.log('broadcast value: ', value)
		if(peer_id) {
			// update broadcast of peer
			Vue.set(state.peers[peer_id], 'broadcasting', value);
		} else {
			// update broadcast of self
			Vue.set(state.self, 'broadcasting', value);
		}
	},

	setView(state, obj) {
		// console.log(obj)
		for(let key in obj) {
			// console.log(key, obj[key])
			Vue.set(state.view, key, obj[key])
		}
	}
}